import { Box, Grid, Paper, Typography } from "@material-ui/core";
import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";


function Stats({imgLink, counter, title}){
    return(
        <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignitems: "center",
                      gap:"2rem",
                      padding: "15px 45px",
                      borderRadius: "18.694px",
                      border: "0.935px solid #D9D9D9",
                    marginBottom: "10px",

                      background: "#FFF",

                      boxShadow:
                        "0px 2.73888px 2.73888px 0px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <img
                      src={imgLink}
                      alt="logo"
                      style={{
                        width: "60px",
                        height:"60px"
                      }}
                    />

                    <Box>
                      <Typography
                        style={{
                          color: "#636363",
                          fontSize: "22px",
                          fontWeight: "500",
                          margin: "0"
                        }}
                      >
                       {counter}
                      </Typography>

                      <Typography
                        style={{
                          color: "#474747",
                          fontSize: "13px",
                          fontWeight: "500",
                          marginTop: "-5px"
                        }}
                      >
                       {title}
                      </Typography>
                    </Box>
                  </Grid>
    )
}


const EventsPoints = () => {

    const statsData = [{
            imgLink:"/assets/mdi_hand-coin-outline.png",
            counter:"100,000",
            title:"Total Loyalty Points"
    },{
            imgLink:"/assets/streamline_money-cash-bag-dollar-bag-payment-cash-money-finance.png",
            counter:"$100",
            title:"Total Coin Worth"
    },{
            imgLink:"/assets/mdi_hand-coin-outline (1).png",
            counter:"50,000",
            title:"Available Loyalty Points"
    },{
            imgLink:"/assets/mdi_hand-coin-outline (2).png",
            counter:"50,000",
            title:"Used Loyalty Points"
    }]


  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Paper
            style={{
              boxShadow: "none !important",
              border: "1px solid rgba(76, 78, 100, 0.25)",
              padding:"15px",
              borderRadius: "10px",
            }}
          >
            <Grid container spacing={5} style={{ minHeight: "60vh" }}>
              {/* Graph */}
              <Grid
                item
                xs={6}
                
              >

                 <Paper
            style={{
              boxShadow: "none !important",
              border: "1px solid rgba(76, 78, 100, 0.25)",
              padding:"15px",
              borderRadius: "10px",
            }}>

            
                <LineChart
                  xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                  series={[
                    {
                      data: [2, 5.5, 2, 8.5, 1.5, 5],
                      area: true,
                    },
                  ]}
                  width={600}
                  height={380}
                />
                </Paper>
              </Grid>

              {/* Stats */}

              <Grid
                item
                xs={6}
               
              >
                <Grid container xs={8}  >

                    {
                        statsData.map((item, _)=>(
                            < >
                                  <  Stats imgLink={item.imgLink} counter={item.counter} title={item.title} />
                            </>
                        ))
                    }

                  
                  
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default EventsPoints;
